import { atom } from 'recoil';

export const refreshAdditionalCoveragesAtom = atom<object>({
    key: 'refreshAdditionalCoverages',
    default: {}
});
